import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, PortalConfigurationService } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
@Component({
    selector: 'da-coupon-code-value',
    templateUrl: './coupon-code-value.component.html',
    styleUrls: ['./coupon-code-value.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CouponCodeValueComponent implements OnInit {
    @Input() codeValue: string;
    @Input() currency: string;
    constructor(
                private _configurationService: ConfigurationService,
                private _portalConfigurationService: PortalConfigurationService
    ) {}

    private _$pricePattern: BehaviorSubject<string> = new BehaviorSubject('');
    public get pricePattern$(): Observable<string> {
        return this._$pricePattern.asObservable();
    }

    private _$formattedCouponCodeValue: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedCouponCodeValue$(): Observable<string> {
        return this._$formattedCouponCodeValue.asObservable();
    }

    ngOnInit() {
        this.formatingCouponCodeValue();
    }


    private formatingCouponCodeValue(){      
        if (this._configurationService.isPartnerPage()) {
                this._portalConfigurationService.currencyPattern$.subscribe((currencyPattern) => {
                    this._$formattedCouponCodeValue.next(this.formatPrice(this.codeValue, currencyPattern));
                });
        } else {
            this._$pricePattern.next('#.##0,00 " $"');
            this._$formattedCouponCodeValue.next(this.formatPrice(this.codeValue, this._$pricePattern.getValue()));
        }
    }

    private formatPrice(price: any, formatPattern){
        if (formatPattern){
            return this._configurationService.formatPrice(price, formatPattern, this.currency);
        } else {
            return price;
        }
    }
}
